import { render, staticRenderFns } from "./RetryVerification.vue?vue&type=template&id=670caaab"
import script from "./RetryVerification.vue?vue&type=script&lang=js"
export * from "./RetryVerification.vue?vue&type=script&lang=js"
import style0 from "./RetryVerification.vue?vue&type=style&index=0&id=670caaab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports